//React
import { FunctionComponent } from "react";
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";
import { selectRteTileData } from "../../redux/selectors/rte/select-rte-tile-data";
import { selectAreaIsState } from "../../../area-info/redux/selectors/select-area-is-state";
import { selectIsQmiFinder } from "../../../system/redux/selectors/select-is-qmi-finder";

const RteCard: FunctionComponent = (props) => {
	const rteTileData = useAppSelector(selectRteTileData);
	const areaIsState = useAppSelector(selectAreaIsState);
	const isQmiFinder = useAppSelector(selectIsQmiFinder);

	if (!rteTileData.showTile || areaIsState || isQmiFinder) {
		return null;
	}

	const handleTileClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
		const rfiButton = document.querySelector<HTMLButtonElement>("#rfi-btn");
		if (rfiButton) {
			const url = new URL(window.location.href);
			window.history.pushState(null, null, url.origin + url.pathname + "?rfi-rte" + url.search.replace("?", "&") + url.hash);
			rfiButton.click();
		}
	}

	return (
		<div className="coveo-list-layout CoveoResult" role="listitem">
			<a
				role="link"
				tabIndex={0}
				aria-label="RedTag event tile"
				className="cf-rte-tile"
				onClick={(e) => {handleTileClick(e)}}
			>
				<div className={rteTileData.tileClass}>
					<div className="red-tag-logo">
						<img src={rteTileData.imageUrl} width="50px" />
					</div>
					<div className={rteTileData.textDivClass}>
						{rteTileData.tileText}
					</div>
					<div className="red-tag-cta-two">
						{rteTileData.tileTextTwo}
						<span className="banner-arrow">
							<svg
								xmlns="https://www.w3.org/2000/svg"
								viewBox="0 0 15 15"
								//style="enable-background:new 0 0 15 15;"
								//xml:space="preserve"
							>
								<path
									d="m15 7.48-4.63 7.12H5.53l3.04-5.2H0V5.56h8.57L5.53.39h4.84L15 7.48z"
									style={{ fill: "white" }}
								></path>
							</svg>
						</span>
					</div>
				</div>
			</a>
		</div>
	);
};

export default RteCard;
